var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ErrorPage',{attrs:{"code":"404","status":"Not Found","href":_vm.$urls.APP_HOME,"href-text":"Go to Gears App"}})}
var staticRenderFns = []

export { render, staticRenderFns }